export default "__VITE_ASSET__CQG9khxT__"